<div class="container"*ngIf="name">
  <span class="name">{{name}}</span>
  <nv-pill class="pill" [isInverted]="true">
    {{ selected }} of {{ total }}
  </nv-pill>
</div>